import { render, staticRenderFns } from "./printQuestionAnswerList.vue?vue&type=template&id=28cdb494&scoped=true"
import script from "./printQuestionAnswerList.vue?vue&type=script&lang=js"
export * from "./printQuestionAnswerList.vue?vue&type=script&lang=js"
import style0 from "./printQuestionAnswerList.vue?vue&type=style&index=0&id=28cdb494&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28cdb494",
  null
  
)

export default component.exports